import client from "./client";

const getBidsByLoadId = (loadId) => {
  return client
    .get(`/bids/load/${loadId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const getMyBidsByLoadId = (loadId) => {
  return client
    .get(`/bids/${loadId}/my-bids`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const getBids = (filter) => {
  return client
    .get(`/bids/paginated`, filter)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const createBid = (data) => {
  return client
    .post("/bids", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const deleteBids = (data) => {
  return client
    .delete(`/bids`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => error.response);
};

const updateBid = (data) => {
  return client
    .patch(`/bids`, data)
    .then((response) => {
      return response;
    }).catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const cancelBid = (bidId) => {
  return client
    .delete(`/bids/${bidId}/cancel`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const bidAPI = {
  createBid,
  updateBid,
  deleteBids,
  cancelBid,
  getBids,
  getBidsByLoadId,
  getMyBidsByLoadId,
};

export default bidAPI;
